import React from "react";
import { isEmpty } from "../../../../services/general.utils";
import { useTranslation } from "react-i18next";

const BenefitGroupLocationUpdatedInfo = ({ notification }) => {
  const { t } = useTranslation();

  return (
    <>
      {!isEmpty(notification.payload.benefit_group_name) && (
        <h4 className="notification-title">
          {t("benefit_group_loc_change_for_user", {
            location: notification.payload.benefit_group_name
          })}
        </h4>
      )}
      <p className="subtitle-description">{t("check_your_benefits")}</p>
    </>
  );
};

export default BenefitGroupLocationUpdatedInfo;
